const homePageBg = '#F9F9F9';

export const sxStyles = {
  heroBg: {
    overflow: 'hidden',
    backgroundColor: homePageBg,
  },
  schoolsContainer: {
    backgroundColor: homePageBg,
    overflowX: 'hidden',
  },
};
